import { render, staticRenderFns } from "./tab2content.vue?vue&type=template&id=44fb25ea&scoped=true&"
import script from "./tab2content.vue?vue&type=script&lang=js&"
export * from "./tab2content.vue?vue&type=script&lang=js&"
import style0 from "./tab2content.vue?vue&type=style&index=0&id=44fb25ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fb25ea",
  null
  
)

export default component.exports